import Navbar from "../../components/main/Navbar";
import SearchHeader from "../../components/main/SearchHeader";
import Loading from "../../components/atoms/Loading";
import Table2 from "../../components/main/Table/Table2";
import {HeaderServiceList} from "../../data/TablesHeader";
import ListsOperations from "../../tools/consts";
import Pagination from "../../components/main/Pagination";
import DeleteModal from "../../components/atoms/DeleteModal";
import {Toaster} from "react-hot-toast";
import React from "react";
import TableSearchHeader from "../../components/CustomTable/TableSearchHeader";
import {useServiceContext} from "./ServiceContext";
import ModalService from "./ServiceModal";

const ServiceScreen = () => {
    const {
        listState,
        modalState,
        onSearchBtnClick,
        changePage,
        deleteDeviceModel,
        closeModal,
        openModal,
        onEditServiceBtnClick,
        deleteServiceClick
    } = useServiceContext();


    return (<div className="pb-7.5px ">
        <Navbar titles={["دستگاه‌ها", "خدمات پس از فروش"]}/>
        <div
            className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px  "
            dir="rtl">
            <TableSearchHeader
                title={"فهرست خدمات پس از فروش"}
                number={listState.countAll}
                placeholder={"جست و جو: شماره سریال، شماره خدمات و..."}
                onSearchBtnClick={onSearchBtnClick}
                countUnit={""}
                buttnText={"ثبت ورودی جدید"}
                hasBtn={true}
                exportFile={false}
                // path={"/admin/device/models/add"}
                onClick={() => {
                    openModal("add", null)
                }}
            />

            {listState.loading ? (<Loading height={"h-66"}/>) : (<>
                <Table2
                    headers={HeaderServiceList}
                    tableData={listState.list}
                    emptyText={"تعمیر و یا تعویضی یافت نشد."}
                    hasOperation={true}
                    pageNumber={listState.pageNumber}
                    limit={listState.pageLimit}
                    operations={ListsOperations.getDeviceServiceList((item) => openModal("delete", item), onEditServiceBtnClick)}
                />
                <Pagination
                    changePage={changePage}
                    countAll={listState.countAll}
                    currentPage={listState.pageNumber}
                />
            </>)}
            {/* Service modal */}
            <ModalService/>
            {/* Delete modal */}
            <DeleteModal
                text={`آیا برای حذف “${modalState.selectedItem == null ? "" : modalState.selectedItem.serviceNumber}” مطمئن هستید؟`}
                showDeleteModal={modalState.isOpen && modalState.mode === "delete"}
                closeDeleteModal={closeModal}
                RemoveItem={deleteServiceClick}
                title={"اخطار حذف دستگاه"}
            />
            <Toaster/>
        </div>
    </div>);
}

export default ServiceScreen